import { useNavigate } from "react-router-dom";
import { PaziaButton, PaziaLoader } from "components/atoms";
import { useCourseGroupWaitlist } from "api/coursegroups";
import { routes } from "consts";
import { formatDate } from "utils";

interface Props {
  courseGroupId: string;
}

export const CourseGroupWaitlistTab = ({ courseGroupId }: Props) => {
  const { isLoading, entries } = useCourseGroupWaitlist(courseGroupId);
  const navigate = useNavigate();

  const handleSendEmail = () => {
    navigate(`${routes.EMAILS}${routes.SCHEDULED_EMAILS_CREATE}?waitlistCourseGroupId=${courseGroupId}`);
  };

  if (isLoading) return <PaziaLoader position="center" />;

  return (
    <div>
      <h3 className="mb-4 text-lg font-medium text-slate-800 dark:text-slate-200">Lista oczekujących</h3>
      {entries.length === 0 ? (
        <p className="text-sm text-slate-500 dark:text-slate-400">Brak wpisów na liście oczekujących.</p>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-200 dark:border-slate-700">
                  <th className="py-2 pr-6 text-left font-medium text-slate-600 dark:text-slate-400">Imię</th>
                  <th className="py-2 pr-6 text-left font-medium text-slate-600 dark:text-slate-400">Email</th>
                  <th className="py-2 text-left font-medium text-slate-600 dark:text-slate-400">Data zapisu</th>
                </tr>
              </thead>
              <tbody>
                {entries.map((entry) => (
                  <tr key={entry.id} className="border-b border-slate-100 dark:border-slate-800">
                    <td className="py-3 pr-6 text-slate-800 dark:text-slate-200">{entry.name}</td>
                    <td className="py-3 pr-6 text-slate-800 dark:text-slate-200">{entry.email}</td>
                    <td className="py-3 text-slate-500 dark:text-slate-400">{formatDate(entry.createdDate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-8 border-t border-slate-200 pt-6 dark:border-slate-700">
            <p className="mb-4 text-sm text-slate-500 dark:text-slate-400">
              Odbiorcy: {entries.length} {entries.length === 1 ? "osoba" : "osób"}
            </p>
            <PaziaButton type="primary" onClick={handleSendEmail}>
              Wyślij email do listy oczekujących
            </PaziaButton>
          </div>
        </>
      )}
    </div>
  );
};
